import {isInViewport, isTouchDevice, videoDataLayers} from "../helpers";

$(document).ready(function () {

    $('.product-composition-video-wrapper video').each(function () {
        let element = this;
        if (isTouchDevice()) {
            document.addEventListener('scroll', theme.debounce(function () {
                if (isInViewport(element)) {
                    element.play();
                } else {
                    element.pause();
                }
            }, 250), {
                passive: true
            });
        }

        videoDataLayers(element);

    }).mouseenter(
        function () {
            this.play()
        }
    ).mouseleave(
        function () {
            this.pause()
        }
    )
})